import Raven from 'raven-js';

const SET_URL = 'SET_URL';

const getters = {
  getUrl(state) {
    return state.url;
  },
};


const actions = {
  setUrl({ commit }, url) {
    commit(SET_URL, url);
    Raven.setTagsContext({ api: url });
  },
};

const mutations = {
  [SET_URL](state, url) {
    state.url = url;
  },
};

export default {
  namespaced: true,
  state: {
    url: null,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/apiUrl.js